import { gql } from '@apollo/client'
import { pick } from 'ramda'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useGenericState } from '../../../../../../packages/kiti/components/helpers/GenericState'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { useSelectedPerspective } from '../../../_shared/PerspectiveDropdown'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePeriodicNonCompliancesState = () => React.useContext(Context)
export const usePeriodicNonCompliances = () => usePeriodicNonCompliancesState()?.periodicNonCompliances

const QUERY = gql`
  query PeriodicNonCompliances($filter: PeriodicNonCompliancesFilter) {
    periodicNonCompliances(filter: $filter) {
      totalCount
      nonCompliancesCount
      date
    }
  }
`

const PeriodicNonCompliancesLoader = ({ children }) => {
  const filter = useCleanFilterForRequest() || {}
  const { value } = useGenericState()
  const perspective = useSelectedPerspective()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        perspective: perspective?.id, //
        nonComplianceType: value?.nonComplianceType?.id || 'service_order',
        ...pick(['placeIds', 'placeLevelIds', 'userIds', 'checklistIds', 'date'], filter)
      }
    },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PeriodicNonCompliancesLoader
